export default __webpack_public_path__ + "static/busy-782b6cc45e298613bdadc6c94b10c7cb.svg";